import { useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export default function useResizeObserver(
  element: Element | null | undefined,
  onResize: () => void,
) {
  useEffect(() => {
    if (!element) return;

    onResize();

    const resizeObserver = new ResizeObserver(onResize);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [element, onResize]);
}
